module.exports = new __parcel__URL__("machines_bp_fire_storm_tracker_cosmetic_level_1.c1ab1a78.png").toString();